import { render, staticRenderFns } from "./messageBoard.vue?vue&type=template&id=4204a76d&scoped=true"
import script from "./messageBoard.vue?vue&type=script&lang=js"
export * from "./messageBoard.vue?vue&type=script&lang=js"
import style0 from "./messageBoard.vue?vue&type=style&index=0&id=4204a76d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4204a76d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4204a76d')) {
      api.createRecord('4204a76d', component.options)
    } else {
      api.reload('4204a76d', component.options)
    }
    module.hot.accept("./messageBoard.vue?vue&type=template&id=4204a76d&scoped=true", function () {
      api.rerender('4204a76d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/groupReporting/messageBoard.vue"
export default component.exports